'use strict';

var React = require('react');
var reactUtils = require('@sravni/react-utils');
var sizes = require('../../../constants/sizes.js');
require('../../Typography/src/Heading.js');
require('../../Typography/src/Link.js');
require('../../Typography/src/ListItem.js');
require('../../Typography/src/OrderedList.js');
var Text = require('../../Typography/src/Text.js');
require('../../Typography/src/UnorderedList.js');
var Avatar_module = require('../styles/Avatar.module.less.js');
var SizeContext = require('./SizeContext.js');

function _interopNamespaceDefault(e) {
    var n = Object.create(null);
    if (e) {
        Object.keys(e).forEach(function (k) {
            if (k !== 'default') {
                var d = Object.getOwnPropertyDescriptor(e, k);
                Object.defineProperty(n, k, d.get ? d : {
                    enumerable: true,
                    get: function () { return e[k]; }
                });
            }
        });
    }
    n.default = e;
    return Object.freeze(n);
}

var React__namespace = /*#__PURE__*/_interopNamespaceDefault(React);

const getTextSize = (size) => {
    switch (size) {
        case 60:
            return sizes.FONT_SIZES.S20;
        case 36:
        case 44:
        case 52:
        default:
            return sizes.FONT_SIZES.S16;
    }
};
/**
 * @description The Avatar component is used to represent users. And should only be used for avatars and logotypes
 *
 * @component
 * @example
 * ```jsx
 * <Avatar src="image.png" />
 * ```
 */
const Avatar = React__namespace.forwardRef((props, ref) => {
    const groupSize = React__namespace.useContext(SizeContext.default);
    const { size, src, className, children, ...restProps } = props;
    const cx = reactUtils.useStyles(Avatar_module.default);
    const classNames = cx(className, 'avatar', {
        [`size-${groupSize || size}`]: size,
    });
    const content = React__namespace.useMemo(() => {
        if (src) {
            return React__namespace.createElement("img", { className: cx('image'), src: src, alt: "avatar", loading: "lazy" });
        }
        return (React__namespace.createElement(Text.Text, { strong: true, uppercase: true, size: getTextSize(size) }, children));
    }, [children, cx, size, src]);
    return (React__namespace.createElement("div", { ref: ref, "data-qa": "Avatar", className: classNames, ...restProps }, content));
});
Avatar.defaultProps = {
    size: sizes.CONTAINER_SIZES.S44,
};
Avatar.displayName = 'Avatar';

exports.Avatar = Avatar;
//# sourceMappingURL=Avatar.js.map
